import { Stack } from "@mantine/core"
import { LabelWithTooltip } from "@tfg/ui"

import { LanguageSelector } from "~/components/LanguageSelector"
import { FormFieldConfig } from "~/pages/Admin/components/TypesForm"

export const LanguageSelectField = (fields: FormFieldConfig, form: any) => (
  <Stack gap="var(--mantine-spacing-xxs)">
    <LabelWithTooltip
      label={fields.label}
      hoverHelperText={fields.tooltip}
      justify="space-between"
      fw={600}
      withAsterisk={fields.required ?? false}
    />
    <LanguageSelector
      classNames={fields.customClass}
      key={fields.name}
      placeholder={fields.placeholder}
      labelProps={{
        fz: "xs",
        fw: 600,
      }}
      error={!form.isValid(fields.name) && form.isTouched()}
      disabled={fields.disabled}
      {...form.getInputProps(fields.name)}
    />
  </Stack>
)
